/**
 * @file 摇号批次选项
 */

import { Button, Ellipsis, Modal } from '@seiue/ui'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'
import { Batch, BatchReq } from 'packages/sdks-next/growp'

import { getTheme } from '@/utils/theme'

import { EditOpenContent } from './EditOpenContent'

/**
 * 摇号批次块
 *
 * @param param - 参数
 * @param param.setBatchs - 设置批次列表
 * @param param.batchs - 批次列表
 * @param param.batch - 当前批次
 * @param param.batchIndex - 当前批次在列表的位置
 * @returns 组件
 */
export const BatchBox: React.FC<{
  setBatchs: (op: BatchReq[]) => void
  batchs: BatchReq[]
  batch: Batch
  batchIndex: number
}> = ({ setBatchs, batchs, batch, batchIndex }) => {
  const theme = getTheme()
  return (
    <Box>
      <HeaderBox>
        <Ellipsis text={batch.name} />
      </HeaderBox>
      <CountBox>
        <CountTextBox>参与人数: {batch.userCount ?? '-'}</CountTextBox>
        <CountTextBox>中签名额: {batch.quota ?? '-'}</CountTextBox>
      </CountBox>
      <BtnBox>
        <LeftBtnBox>
          <Button
            type="light-text"
            style={{ marginRight: 0 }}
            onClick={() => {
              const { hide } = Modal.open({
                width: 640,
                footer: null,
                bodyStyle: {
                  padding: '0',
                },
                title: '编辑摇号批次',
                children: (
                  <EditOpenContent
                    hide={() => hide()}
                    setBatchs={setBatchs}
                    batchs={batchs}
                    batch={batch}
                    batchIndex={batchIndex}
                  />
                ),
              })
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <GrowpIcon
                name="Edit"
                text="编辑"
                size={12}
                color={theme.text._2}
                hoverColor={theme.brand._1}
              />
            </div>
          </Button>
          <Button
            type="light-text"
            style={{ marginRight: 0 }}
            onClick={() => {
              batchs.splice(batchIndex, 1)
              setBatchs([...batchs])
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <GrowpIcon
                name="Shanchu"
                text="删除"
                size={12}
                color={theme.text._2}
                hoverColor="#F54545"
              />
            </div>
          </Button>
        </LeftBtnBox>
      </BtnBox>
    </Box>
  )
}

const Box = styled.div`
  border: 1px solid ${(props) => props.theme.border.greyNormal};
  width: 398px;
  height: 124px;
  border-radius: 8px;
  padding: 20px 20px 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &:hover {
    border-color: transparent;
    box-shadow: 0px 0px 1px 0px rgba(21, 29, 41, 0.1),
      0px 0px 8px 0px rgba(21, 29, 41, 0.02),
      0px 12px 20px 0px rgba(21, 29, 41, 0.08);
  }
`

const HeaderBox = styled.div`
  width: 100%;
  height: 24px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => props.theme.text._1};
`

const CountBox = styled.div`
  display: flex;
  gap: 32px;
  height: 22px;
  color: ${(props) => props.theme.text._3};
`

const CountTextBox = styled.div`
  color: ${(props) => props.theme.text._2};
`

const BtnBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const LeftBtnBox = styled.div`
  display: flex;
`
